/**
 * @architecture-header 1
 * @layer routes
 * @domain workspace-shell
 * @responsibility Render account-related phone pages without reusing desktop dialog chrome.
 * @state-owner local settings tab state
 * @allowed-imports React; app providers; shared components; settings content; mobile page frame
 * @forbidden desktop ModalDocument; direct API client; role switching
 * @public-api MobileWorkspaceShell
 * @side-effects settings children own their mutations
 * @tests frontend/apps/web/e2e/workspace.spec.ts
 */

import { MainEmpty } from '../../shared/components/ListColumn';
import { useTranslator } from '../../shared/model/use-workspace';
import { MobilePageFrame } from './MobilePageFrame';

export function MobileAccountPlaceholderPage({
  kind,
  onBack,
}: {
  kind: 'profile' | 'notifications';
  onBack(): void;
}) {
  const t = useTranslator();
  const copy =
    kind === 'profile'
      ? {
          title: t('帳號資料'),
          empty: t('帳號資料正在準備中'),
          description: t('姓名與頭像設定會在這裡集中管理。'),
        }
      : {
          title: t('通知設定'),
          empty: t('通知設定正在準備中'),
          description: t('收件匣與提醒偏好會在這裡集中管理。'),
        };
  return (
    <MobilePageFrame onBack={onBack} title={copy.title}>
      <MainEmpty description={copy.description} title={copy.empty} />
    </MobilePageFrame>
  );
}
